// extracted by mini-css-extract-plugin
export default {"section_wrapper":"HomePage_section_wrapper__fICr2"};